import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UsersTable from './UsersTable';
import InviteUserDialog from './InviteUserDialog';

export default function UsersTab() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [mode, setMode] = useState('create');
  const [pagination, setPagination] = useState({ page: 0, size: 10 });

  const handlePaginationChange = (page, size) => {
    setPagination({ page, size });
  };

  const openCreateDialog = () => {
    setSelectedUser(null);
    setMode('create');
    setDialogOpen(true);
  };

  const openEditDialog = (user) => {
    setSelectedUser(user);
    setMode('edit');
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setSelectedUser(null);
  };

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" sx={{ pb: 2 }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={openCreateDialog}>
          Invite User
        </Button>
      </Stack>

      <UsersTable onEdit={openEditDialog} searchQuery={pagination} onPaginationChange={handlePaginationChange} />

      <InviteUserDialog open={dialogOpen} onClose={closeDialog} user={selectedUser} mode={mode} />
    </>
  );
}
